import React, { RefObject } from 'react';
import { colors } from 'spw-theme';
import styled from 'styled-components';
import CurrencyInput, { CurrencyInputProps } from 'react-currency-input-field';

const Input = styled(CurrencyInput).withConfig({
  shouldForwardProp: (p) => !['error'].includes(p),
})`
  border: 1px solid
    ${(props: { error?: boolean }) =>
      props.error ? colors.red : colors.greyInputAddornment};
  padding-right: 6px;
  padding-left: 6px;
  background-color: ${colors.white};
  border-radius: 4px;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  text-align: right;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;
  font-family: Roboto;

  &:disabled {
    opacity: 0.7;
    border: 1px solid
      ${(props: { error?: boolean }) =>
        props.error ? colors.red : colors.greyInputAddornment} !important;
  }

  &:hover {
    border-color: ${(props: { error?: boolean }) =>
      props.error ? colors.red : colors.black};
  }

  &:focus {
    outline: none !important;
    border-color: ${(props: { error?: boolean }) =>
      props.error ? colors.red : colors.black};
    border-width: 2px;
  }

  &.hasEndAdornment {
    padding-right: 20px;
  }

  &.hasStartAdornment {
    padding-left: 16px;
  }

  &.left-align {
    text-align: left;
  }

  && {
    input {
      text-align: right;
      font-size: 14px;
    }

    &.padding-left-0 {
      input {
        padding-left: 0;
      }
    }

    &.width60 {
      width: 60px;

      input {
        padding: 18.5px 6px;
      }
    }
  }

  &.usf-input {
    input {
      padding-left: 5px;
      padding-right: 10px;
    }
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const EndAdornment = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 6px;

  &.disabled {
    opacity: 0.5;
  }
`;

export const StartAdornment = styled.div`
  position: absolute;
  left: 6px;
  top: 12px;

  &.disabled {
    opacity: 0.5;
  }
`;

interface Props extends CurrencyInputProps {
  endAdornment?: string;
  startAdornment?: string;
  error?: boolean;
  inputRef?: RefObject<HTMLInputElement>;
}

const WorksheetValuesInput: React.FC<Props> = ({
  startAdornment,
  endAdornment,
  error,
  inputRef,
  ...rest
}) => (
  <InputContainer data-testid={(rest as any)['data-testid']}>
    <Input
      {...rest}
      ref={inputRef}
      className={`${rest.className || ''}${
        endAdornment ? ' hasEndAdornment' : ''
      }${startAdornment ? ' hasStartAdornment' : ''}`}
      error={error}
      data-testid={undefined}
      allowNegativeValue={false}
    />
    {startAdornment && (
      <StartAdornment className={rest.disabled ? 'disabled' : ''}>
        {startAdornment}
      </StartAdornment>
    )}
    {endAdornment && (
      <EndAdornment className={rest.disabled ? 'disabled' : ''}>
        {endAdornment}
      </EndAdornment>
    )}
  </InputContainer>
);

export default WorksheetValuesInput;
